<div *transloco="let t" class="flex justify-between items-center w-full">
  <div class="breadcrumbs max-w-full text-sm text-white">
    <ul class="ml-2 md:ml-4">
      @for (crumb of breadcrumbs(); track $index) {
        <li>
          <button
            (click)="onCrumbClicked(crumb.url)"
            [attr.aria-label]="t('shell.breadcrumbs.crumb', { label: crumb.label })"
            class="no-underline!"
          >
            {{ crumb.label }}
          </button>
        </li>
      }
    </ul>
  </div>
  <div class="relative mr-2 md:mr-4">
    <div class="flex items-center h-full">
      <div
        (click)="toggleUserDropdown()"
        (keydown.enter)="toggleUserDropdown()"
        (keydown.space)="$event.preventDefault(); toggleUserDropdown()"
        [attr.aria-label]="userProfileAriaLabel()"
        class="btn btn-lg join-item m-1 rounded-full aspect-square relative h-full user-dropdown-btn"
        role="button"
        tabindex="0"
      >
        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap text-center text-lg">
          @if (initials()) {
            {{ initials() }}
          } @else {
            <i-lucide [img]="benutzerIcon"></i-lucide>
          }
        </div>
      </div>
    </div>
    @if (dropdownVisible) {
      <ul
        [class.opacity-0]="!showDropdown"
        [class.opacity-100]="showDropdown"
        [class.scale-y-0]="!showDropdown"
        [class.scale-y-100]="showDropdown"
        class="absolute right-0 top-full mt-1 menu text-base-content bg-neutral rounded-none z-1000 w-52 p-2 shadow user-dropdown-content transform origin-top-right transition-all duration-200 ease-out"
        tabindex="0"
      >
        @for (item of navItems(); track item.route) {
          <li
            (itemClicked)="onUserMenuItemClicked(item)"
            [icon]="item.icon"
            [name]="t(item.name)"
            [route]="item.route ? item.route() : ''"
            app-dropdown-item-uif
          ></li>
        }
      </ul>
    }
  </div>
</div>
